import { useCallback } from 'react';

import { useUnsavedChangesSessionStore } from '../stores';

type UnsavedChanges = {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (newValue: boolean) => Promise<void>;
};

export const useUnsavedChanges = (): UnsavedChanges => {
  const { hasUnsavedChanges, setHasUnsavedChanges } = useUnsavedChangesSessionStore();

  const internalSetHasUnsavedChanges = useCallback(
    (newValue: boolean) => {
      setHasUnsavedChanges(newValue);
      return Promise.resolve();
    },
    [setHasUnsavedChanges],
  );

  return { hasUnsavedChanges, setHasUnsavedChanges: internalSetHasUnsavedChanges };
};
